import { render, staticRenderFns } from "./donationContent.vue?vue&type=template&id=7cdc1d2c&"
import script from "./donationContent.vue?vue&type=script&lang=js&"
export * from "./donationContent.vue?vue&type=script&lang=js&"
import style0 from "./donationContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports